var rVersion = /^(0|[1-9][0-9]{0,2})\.(0|[1-9][0-9]{0,2})(?:\.(0|[1-9][0-9]{0,2}))?$/;
/**
 * Parses a version value into version number parts.
 * @param value The value to parse
 * @category Value parsers
 */
export var parseVersionParts = function (value) {
    if (!value) {
        return null;
    }
    var groups = rVersion.exec(value);
    if (!groups) {
        return null;
    }
    var numbers = [];
    for (var i = 0; i < 3 && groups[i + 1]; i++) {
        numbers.push(parseInt(groups[i + 1]));
    }
    return numbers;
};
//# sourceMappingURL=version.js.map